var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18.945V20h1a2 2 0 0 1 2 2H8a2 2 0 0 1 2-2h1v-1.055a8.972 8.972 0 0 1-5.206-2.427l-1.055 1.156a1 1 0 0 1-1.478-1.348l1.788-1.959a1 1 0 0 1 1.515.044 7 7 0 1 0 9.557-10.07 1 1 0 1 1 1.18-1.615 9.001 9.001 0 0 1-4.3 16.22z",
    fill: "#335EEA"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#335EEA",
    opacity: 0.3,
    cx: 12,
    cy: 10,
    r: 6
  }))));
};

export { SvgGlobe as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiLz48cGF0aCBkPSJNMTMgMTguOTQ1VjIwaDFhMiAyIDAgMDEyIDJIOGEyIDIgMCAwMTItMmgxdi0xLjA1NWE4Ljk3MiA4Ljk3MiAwIDAxLTUuMjA2LTIuNDI3bC0xLjA1NSAxLjE1NmExIDEgMCAwMS0xLjQ3OC0xLjM0OGwxLjc4OC0xLjk1OWExIDEgMCAwMTEuNTE1LjA0NCA3IDcgMCAxMDkuNTU3LTEwLjA3IDEgMSAwIDExMS4xOC0xLjYxNSA5LjAwMSA5LjAwMSAwIDAxLTQuMyAxNi4yMnoiIGZpbGw9IiMzMzVFRUEiLz48Y2lyY2xlIGZpbGw9IiMzMzVFRUEiIG9wYWNpdHk9Ii4zIiBjeD0iMTIiIGN5PSIxMCIgcj0iNiIvPjwvZz48L3N2Zz4=";